type Placeholders = Record<string, RegExp | null>;

export const placeholders: Placeholders = {
  W: /[A-NPR-Z1-9]/,
};
